// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__3yalG","box":"ContactForm_box__g3x3X"};